import DataService from '@/core/base/service/data.service';
import { Client } from '@/shared/model/client.model';
import { IUser } from '@/shared/model/user.model';
import axios from 'axios';

export default class ClientService extends DataService<Client> {
    protected baseApiUrl: string = 'api/admin/clients';

    public async createUser(clientId: number, user: IUser): Promise<IUser> {
        return new Promise<IUser>((resolve, reject) => {
            axios
                .post(`${this.baseApiUrl}/${clientId}/users`, user)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public async removeUser(clientId: number, userId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            axios
                .delete(`${this.baseApiUrl}/${clientId}/users/${userId}`)
                .then(res => {
                    resolve();
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}
